import { useEffect, useState } from 'react';

export default function Navbar() {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const urlParams = window.location.search;
    const loginLink = document.getElementById('loginLink') as HTMLAnchorElement;

    if (urlParams && loginLink) {
      const cleanParams = urlParams.startsWith('?') ? urlParams.substring(1) : urlParams;
      const linkUrl = new URL(loginLink.href);
      linkUrl.search = cleanParams;
      loginLink.href = linkUrl.toString();
    }
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-lg bg-[#081428]/80 border-b border-white/10">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <img 
              src="https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/bae752f2-e9b0-4924-58be-186e7e7c0c00/public" 
              alt="LawX Logo" 
              className="h-8 w-auto"
            />
          </a>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#tools" className="text-gray-300 hover:text-[#28E7C5] transition-colors">
              Ferramentas
            </a>
            <a href="#compare" className="text-gray-300 hover:text-[#28E7C5] transition-colors">
              LawX vs ChatGPT
            </a>
            <a href="/blog" className="text-gray-300 hover:text-[#28E7C5] transition-colors">
              Blog
            </a>
            <a 
              id="loginLink"
              href="https://plataforma.lawx.ai/dashboard" 
              className="text-gray-300 hover:text-[#28E7C5] transition-colors"
            >
              Login
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            type="button"
            aria-label="Abrir menu"
            aria-expanded={isMobileOpen}
            onClick={() => setIsMobileOpen((prev) => !prev)}
            className="md:hidden text-gray-200 hover:text-[#28E7C5] transition-colors"
          >
            <svg
              className="h-6 w-6"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              {isMobileOpen ? (
                <>
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </>
              ) : (
                <>
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </>
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-3">
              <a
                href="#tools"
                onClick={() => setIsMobileOpen(false)}
                className="text-gray-300 hover:text-[#28E7C5] transition-colors"
              >
                Ferramentas
              </a>
              <a
                href="#compare"
                onClick={() => setIsMobileOpen(false)}
                className="text-gray-300 hover:text-[#28E7C5] transition-colors"
              >
                LawX vs ChatGPT
              </a>
              <a
                href="/blog"
                onClick={() => setIsMobileOpen(false)}
                className="text-gray-300 hover:text-[#28E7C5] transition-colors"
              >
                Blog
              </a>
              <a
                id="loginLink"
                href="https://plataforma.lawx.ai/dashboard"
                onClick={() => setIsMobileOpen(false)}
                className="text-gray-300 hover:text-[#28E7C5] transition-colors"
              >
                Login
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}